import { Component, Input, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../../data/language.service';
import { AuthService } from '../../../../core/authentication/auth.service';
import { catchError, finalize } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-navbar-choose-language',
  templateUrl: './navbar-choose-language.component.html',
  styleUrls: ['./navbar-choose-language.component.scss'],
  standalone: false
})
export class NavbarChooseLanguageComponent {
  translate = inject(TranslateService);
  private languageService = inject(LanguageService);
  private authService = inject(AuthService);

  @Input() readonly mode: 'white' | 'black' = 'black';


  constructor() {
  }

  changeUserLanguage(language: string): void {
    if (this.authService.email && this.translate.currentLang !== language) {
      this.languageService
        .changeLanguage(language)
        .pipe(
          catchError(() => of([])),
          finalize(() => {
          }),
        )
        .subscribe((result) => {
        });
    }
  }
}
